import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import {
  addChargeDocFeedback,
  editInvestigation,
} from "services/advocateComplaintService";
import { AdvocateComplaints, Investigation } from "types";
import { LoadingIcon } from "utils/constant";
import {
  ADVOCATE_INVESTIGATION_STATUS,
  FEEDBACK_TYPE,
  FEEDBACK_TYPE2,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { useTranslation } from "contexts/i18nContext";
import "../../complaintRequest/styles/AddEvidenceModal.css";

interface FeedbackModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: AdvocateComplaints;
  investigationData: Investigation;
  onRefresh: any;
}

export default function AddChargeFeedbackModal({
  isOpen,
  setIsOpen,
  complaintData,
  investigationData,
  onRefresh,
}: FeedbackModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    feedback: "",
    feedback_status_charge_docu: FEEDBACK_TYPE?.APPROVED,
    complaint: null,
    status: INVESTIGATION_STATUS?.ON_CHARGE,
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    // setError(null);
    // setSuccess(false);

    if (!investigationData) return;

    const data = {
      ...formState,
      status:
        formState.feedback_status_charge_docu === FEEDBACK_TYPE?.REVISE
          ? ADVOCATE_INVESTIGATION_STATUS?.BACK_TO_PROSECUTOR
          : ADVOCATE_INVESTIGATION_STATUS?.ON_CHARGE,
      admin_unit_id: complaintData?.admin_unit_id || "",
      org_id: complaintData?.org_id || "",
      accused_advocate_name: complaintData?.accused_name || "",
      user_id_accused_advocate: complaintData?.userid_accused_name || "",
      accused_license_number: complaintData?.accused_license_number || "",
      complaint: complaintData?.uu_id || null,
      is_prosecutor_charge_doc: false,
    };
    const investigation_id = investigationData?.uu_id || "";
    const isFormData = false;

    try {
      const resData = await editInvestigation(
        data,
        investigation_id,
        isFormData,
      );

      if (resData) {
        await addChargeDocFeedback({
          investigation: investigation_id,
          comment: formState.feedback,
        });
      }

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      // setSuccess(true);
      setFormState({
        feedback: "",
        feedback_status_charge_docu: FEEDBACK_TYPE?.APPROVED,
        complaint: null,
        status: INVESTIGATION_STATUS?.ON_CHARGE,
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      //   err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("addChargeFeedback")}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              {t("feedbackType")}
            </label>
            <select
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              name="feedback_status_charge_docu"
              value={formState.feedback_status_charge_docu}
              onChange={handleChange}
            >
              {Object.values(FEEDBACK_TYPE2)?.map((list) => (
                <option key={list} value={list}>
                  {list}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("chargeFeedback")}
            </label>
            <textarea
              required
              rows={7}
              name="feedback"
              value={formState.feedback}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("addFeedback")
          )}
        </button>
      </form>
    </SideModal>
  );
}
